import styled, { css } from "styled-components";
import { Flex, Stack } from "@wearewqa/wqa-design-system";

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const StyledFlexContainer: any = styled(Flex)(
  () => css`
    min-height: 100vh;
    padding: 16px;
  `
);

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const StyledStackContainer: any = styled(Stack)(
  () => css`
    max-width: 360px;
    width: 100%;
  `
);

export const StyledDivInfoBox = styled.div(
  ({ theme: { color } }) => css`
    border-radius: 8px;
    border: 1px solid ${color.semantic.error[300]};
    background-color: ${color.semantic.error[100]};
    padding: 8px 16px;
  `
);
